import Vue from 'vue';
import Vuex from 'vuex';

import core from '@/CORE/store';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  modules: {
    core
  },
});

export default store


// WEBPACK FOOTER //
// ./src/CUSTOM/store/index.js